
<div (click)="$event.stopPropagation()">
  <button class="close-button" (click)="onCloseClick()">
  <span aria-hidden="true">&times;</span>
  </button>
  <h1 mat-dialog-title>Verify OTP</h1>
  <div mat-dialog-content>
    <p *ngIf="timeLeft > 0">
      <span>We have sent an OTP to your {{ data.sendMethod }}.</span> 
      <br/>
      <span class="grey-text">(This OTP will be valid for next {{ counter }})</span>    
    </p>
    <p *ngIf="timeLeft == 0">
      <span>OTP has been expired.</span> 
      <button *ngIf="timeLeft == 0" mat-button class="button button-red btnResend" (click)="resendOTP()">ReSend</button>
    </p>
    <mat-form-field>
      <input matInput type="text" maxlength="6" class="poReference" [(ngModel)]="OTPCode" (keyup.enter)="validateOTP()" placeholder="Please enter 6 digits" />
    </mat-form-field>
  </div>
  <div mat-dialog-actions>
    <button mat-button class="button button-red button-large continue" (click)="validateOTP()">Continue</button>
  </div>
  <div class="info">This may take up to 60 seconds to receive the code. If you haven't received your code, please <span class="underline" (click)="resendOTP()">click here</span> to resend.</div>
</div>